// GRAPHQL QUERIES
import { gql } from "apollo-boost";

export const GET_DEPARTMENTS = gql`
  query {
    sectors {
      nome
      codsetor
      notificacaototem
      ativo
      icone
      data_cadastro
    }
  }
`;
